import React, { useEffect, useState } from "react";
import { useTable, useSortBy } from "react-table";
import moment from "moment";
import { dispatch } from "@rematch/core";
import { Icon, Dropdown, Button, Popup,Pagination } from "semantic-ui-react";
import FilterColumns from "./FilterColumns";
import NothingToShow from "../../../drive/NothingToShow";
import tableActions from "./tableActions.json";
import contentTypes from "./contentTypes.json";
import contentStatus from "./contentStatus.json";
const ReactTable = ({
  data,
  tableFilterQuery,
  totalRecords,
  handleNameFilter,
  routeParams,
  handleHeaderClick,
  handlePagination,
  sortOrder,
  sortColumn,
  selectedAccount,
  handleDropdownFilter,
  categoryTreeList,
  categoryList,
  handleDropdownActions,
  handleResetFilters,
  filterState,
  setFilterState,
  ...props
}) => {
  const Actions = tableActions;
  const typeArray = contentTypes;
  const statusArray = contentStatus;

  const updateFilterState = (key, value) => {
    setFilterState((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const [columns, setColumns] = useState([
    {
      Header: "Type",
      accessor: "type",
      hidden: false,
      Cell: ({ value }) => {
        const category = typeArray.find((item) => item.value === value);
        return (
           <div style={{ display: "flex", justifyContent: "flex-start"}}>
            <Icon name={category.icon} />
            <span style={{ marginLeft: "4px" }}>
              {category.text}
            </span>
          </div>
        );
      },
    },
    {
      Header: "Name",
      accessor: "name",
      hidden: false,
      Cell: ({ value }) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "100px",
          }}
        >
          {value.length > 15 ? <Popup className="popupStyled" inverted trigger={
            <span>{`${value.substring(0, 20)}...`}</span>}
            content={value}
          /> : value}
        </div>
      ),
    },
    {
      Header: "Knowledge Bank",
      accessor: "baseCategory",
      hidden: false,
    },
    {
      Header: "Category",
      accessor: "category",
      hidden: false,
    },
    {
      Header: "Sub Category",
      accessor: "subCategory",
      hidden: false,
    },
    {
      Header: "Creator",
      accessor: "authorObj.firstName",
      hidden: false,
      Cell: ({ row }) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          <img
            src={row.original.authorObj.profilePic}
            alt="Author"
            style={{ width: 20, height: 20, borderRadius: "50%" }}
          />
          <span style={{ marginLeft: "4px" }}>
            {row.original.authorObj.firstName} {row.original.authorObj.lastName}
          </span>
        </div>
      ),
    },
    {
      Header: "Status",
      accessor: "status",
      hidden: false,
      Cell: ({ value }) => {
        const category = statusArray.find((item) => item.value === value);
        return (
          <div>
            {category.text}
          </div>
        );
      },
    },
    {
      Header: "Created Date",
      accessor: "createdAt",
      hidden: false,
      Cell: ({ value }) => (
        <div>{moment(value).format("MMM D, YYYY h:mm A")}</div>
      ),
    },
    {
      Header: "Updated Date",
      accessor: "updatedAt",
      hidden: true,
      Cell: ({ value }) => (
        <div>{moment(value).format("MMM D, YYYY h:mm A")}</div>
      ),
    },
    {
      Header: "",
      accessor: "actions",
    },
  ]);
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
     useTable({ columns, data }, useSortBy);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [showFilters, setShowFilters] = useState(true);
  const [showList, setShowList] = useState(true);
  const pageCount = Math.ceil(totalRecords / pageSize);

  const selectContent = async (e, row) => {
    e.stopPropagation();
    await dispatch.content.setSelectedContent(row.original);
    await dispatch.content.splitAt("60%");
    await dispatch.content.openResourcePane("ContentDetail");
    await dispatch.app.setCollapsedResourcePaneIndexTemp(null);
  };
  const handlePageClick = (e,data) => {
    const { activePage } = data
    let skip = 0;
    skip = pageSize * (activePage - 1)
    setCurrentPage(activePage);
    handlePagination(skip, pageSize);
  };
  function tooltip(name, content) {
    return <Popup
        trigger={<Icon name={name} />}
        content={content}
        pn="hover"
        position="top center"
        className="popupStyled"
        inverted
    />
}
  const handleSizeChange = (value) => {
    let skip = 0;
    setCurrentPage(1);
    setPageSize(Number(value));
    handlePagination(skip, Number(value));
  };
  const addColumn = (e, i, item) => {
    setColumns((prevColumns) => {
      const updatedColumns = [...prevColumns];
      updatedColumns[i] = {
        ...updatedColumns[i],
        hidden: !updatedColumns[i].hidden,
      };
      return updatedColumns;
    });
  };

  const handleResetFilter = async () => {
    // Reset the filter state
    setFilterState({
      selectedType: null,
      searchText: null,
      selectedBaseCategory: null,
      selectedCategory: null,
      selectedSubCategory: null,
      selectedUser: null,
      selectedStatus: null,
      startDate: null,
      endDate: null,
      mixRange: null,
    });
      handleResetFilters();
    // Define the default query
  };

  const handleTypeClick = (e, rowData) => {
    e.stopPropagation();

    if (rowData.contentpath) {
        const url = rowData.contentpath.startsWith('http://') || rowData.contentpath.startsWith('https://')
            ? rowData.contentpath
            : `http://${rowData.contentpath}`;
        window.open(url, '_blank');
    } else {
        const linkAction = Actions.find(action => action.name === "Link");
        if (linkAction) {
            handleDropdownActions(e, {
                ...linkAction,
                url: rowData.contentPath
            }, rowData);
        }
    }
};


  return (
    <table
      className="react-table"
      {...getTableProps()}
      style={{ borderCollapse: "collapse", width: "100%" }}
    >
      <thead className="table-header">
        {headerGroups.map((headerGroup) => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column) => {
              {
                if (column.hidden) {
                  return null;
                } else {
                  return (
                    <th
                      className={`table-cell-header ${
                        column.id === sortColumn ? "active" : ""
                      }`}
                      {...column.getHeaderProps()}
                      style={{
                        border: "1px solid #D3D3D3",
                        padding: "6px",
                        cursor: column.canSort ? "pointer" : "default",
                      }}
                    >
                      {column.id !== "actions" ? (
                        <div onClick={() => handleHeaderClick(column.id)} style={{display:'flex', alignItems:'center', justifyContent:"center"}}>
                          <div>
                            {column.id === sortColumn ? (
                              sortOrder ? (
                                <Icon name="arrow up" />
                              ) : (
                                <Icon name="arrow down" />
                              )
                            ) : (
                              <Icon name="sort" style={{ color: "#aec3b0" }} />
                            )}{" "}
                          </div>
                          <div>
                          {column.render("Header")}</div>
                        </div>
                      ) : (
                        <Dropdown
                          className="dropdown-icon"
                          icon="ellipsis vertical"
                          pointing="right"
                        >
                          <Dropdown.Menu>
                            <Dropdown.Item
                              icon="filter"
                              text="Advance Filter"
                              onClick={(e) => setShowFilters(!showFilters)}
                            />
                            <Dropdown.Item
                              icon="redo"
                              text="Reset Filter"
                              onClick={handleResetFilter}
                            />
                            <Dropdown.Item
                              icon={"ellipsis vertical"}
                              text={showList ? "List Action" : "Grid Action"}
                              onClick={(e) => setShowList(!showList)}
                            />
                          </Dropdown.Menu>
                        </Dropdown>
                      )}
                    </th>
                  );
                }
              }
            })}
          </tr>
        ))}
        {showFilters
          ? headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => {
                  {
                    if (column.hidden) {
                      return null;
                    } else {
                      return (
                        <th
                          {...column.getHeaderProps()}
                          style={{
                            border: "1px solid #D3D3D3",
                            padding: "6px",
                          }}
                        >
                          <div style={{position: "relative"}}>
                            {column.canSort ? (
                              <FilterColumns
                                column={column}
                                columns={columns}
                                addColumn={addColumn}
                                tableFilterQuery={tableFilterQuery}
                                handleNameFilter={handleNameFilter}
                                selectedAccount={selectedAccount}
                                handleDropdownFilter={handleDropdownFilter}
                                categoryTreeList={categoryTreeList}
                                categoryList={categoryList}
                                routeParams={routeParams}
                                //showFilters={showFilters}
                                // selectedType={selectedType}
                                // setSelectedType={setSelectedType}
                                // selectedCategory={selectedCategory}
                                // setSelectedCategory={setSelectedCategory}
                                filterState={filterState}
                                updateFilterState={updateFilterState}
                              />
                            ) : null}
                          </div>
                        </th>
                      );
                    }
                  }
                })}
              </tr>
            ))
          : null}
      </thead>
      {rows.length === 0 ? (
        <tbody>
          <tr>
            <td
              colSpan={headerGroups[0].headers.length}
              style={{ border: "1px solid #D3D3D3" }}
            >
              <NothingToShow imgStyle={{ display: "block" }} />
            </td>
          </tr>
        </tbody>
      ) : (
        <tbody className="table-body" {...getTableBodyProps()}>
          {rows.map((row) => {
            prepareRow(row);
            return (
              <tr
                className="table-row"
                {...row.getRowProps()}
                key={row.id}
                onClick={(e) => selectContent(e, row)}
              >
                {row.cells.map((cell) => {
                  if (!cell.column.hidden) {
                    if(cell.column.id === "type"){
                    return (
                      <td
                        {...cell.getCellProps()}
                        style={{
                          padding: "6px",
                          border: "1px solid #D3D3D3",
                          cursor: 'pointer',
                        }}
                        onClick={(e) => handleTypeClick(e, row.original)}
                      >
                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            color: '#999999#666666',
                          }}>
                          {cell.render("Cell")}
                        </div>
                      </td>
                    );
                  } else if (cell.column.id === "actions") {
                    return (
                      <td
                        {...cell.getCellProps()}
                        style={{
                          padding: "6px",
                          border: "1px solid #D3D3D3",
                        }}
                      >
                        <div
                          style={{ display: "flex", justifyContent: "flex-start" }}
                        >
                          {!showList ? (
                            <Button.Group>
                              {Actions.map((item, i) => {
                                if (!item.key) {
                                  return item.disabled ? null : (
                                    <Popup
                                       key={i}
                                       content={item.name}
                                       trigger={(
                                    <Button
                                      key={i}
                                      icon
                                      onClick={(e, item) =>
                                        handleDropdownActions(
                                          e,
                                          item,
                                          row.original
                                        )
                                      }
                                      text={item.name}
                                      style={{ padding: "8px" }}
                                    >
                                      <Icon
                                        className={
                                          item.className ? item.className : null
                                        }
                                        name={item.icon ? item.icon : "file"}
                                        style={{ "font-size": "10px" }}
                                      />
                                    </Button>
                                    )}inverted/>
                                  );
                                } else {
                                  return false;
                                }
                              })}
                              {Actions.map((item, i) => {
                                if (item.key) {
                                  return Object.entries(row.original).map(
                                    (key3, value3) => {
                                      if (item.key == key3[0]) {
                                        return key3[1] ? null : (
                                          <Popup
                                             key={i}
                                             content={item.name}
                                             trigger={(
                                          <Button
                                            key={value3}
                                            icon
                                            onClick={
                                              key3[1]
                                                ? null
                                                : (e, item) =>
                                                    handleDropdownActions(
                                                      e,
                                                      item,
                                                      row.original
                                                    )
                                            }
                                            text={item.name}
                                            style={{ padding: "8px" }}
                                          >
                                            <Icon
                                              className={
                                                item.className
                                                  ? item.className
                                                  : null
                                              }
                                              name={
                                                item.icon ? item.icon : "file"
                                              }
                                              disabled={item.disabled}
                                              style={{ "font-size": "10px" }}
                                            />
                                          </Button>
                                          )}inverted/>
                                        );
                                      }
                                    }
                                  );
                                } else {
                                  return false;
                                }
                              })}
                            </Button.Group>
                          ) : (
                            <Dropdown
                              icon="ellipsis vertical"
                              pointing="right"
                              className="dropdown-icon"
                            >
                              <Dropdown.Menu>
                                {Actions.map((item, i) => {
                                  if (!item.key) {
                                    return (
                                      <React.Fragment key={`3_${i}`}>
                                        <Dropdown.Item
                                          key={`4_${i}`}
                                          icon={
                                            item.icon ? (
                                              <Icon
                                                className={item.className}
                                                name={item.icon}
                                              />
                                            ) : null
                                          }
                                          text={item.name}
                                          disabled={item.disabled}
                                          onClick={(e, item) =>
                                            handleDropdownActions(
                                              e,
                                              item,
                                              row.original
                                            )
                                          }
                                        />
                                        <Dropdown.Divider />
                                      </React.Fragment>
                                    );
                                  } else {
                                    return false;
                                  }
                                })}
                                {Actions.map((item, i) => {
                                  if (item.key) {
                                    return Object.entries(row.original).map(
                                      (key3, value3) => {
                                        if (item.key === key3[0]) {
                                          return (
                                            <React.Fragment key={`5_${i}`}>
                                              <Dropdown.Item
                                                icon={
                                                  item.icon ? (
                                                    <Icon
                                                      className={item.className}
                                                      name={item.icon}
                                                    />
                                                  ) : null
                                                }
                                                key={`6_${i}`}
                                                text={item.name}
                                                disabled={key3[1]}
                                                onClick={
                                                  key3[1]
                                                    ? null
                                                    : (e, item) =>
                                                        handleDropdownActions(
                                                          e,
                                                          item,
                                                          row.original
                                                        )
                                                }
                                              />
                                              <Dropdown.Divider />
                                            </React.Fragment>
                                          );
                                        }
                                      }
                                    );
                                  } else {
                                    return false;
                                  }
                                })}
                              </Dropdown.Menu>
                            </Dropdown>
                          )}
                        </div>
                      </td>
                    );
                  } else {
                    return (
                      <td
                        {...cell.getCellProps()}
                        style={{
                          padding: "6px",
                          border: "1px solid #D3D3D3"
                        }}
                      >
                        {cell.render("Cell")}
                      </td>
                    );
                  }
                }
                  return null;
                })}
              </tr>
            );
          })}
        </tbody>
      )}
      {rows.length > 0 ? (
        <tfoot
          style={{
            padding: "5px",
            border: "1px solid #D3D3D3",
            backgroundColor:"rgb(243 244 246)"
          }}
        >
          <tr>
            <td colSpan={headerGroups[0].headers.length} style={{ padding: '8px', background: '#f8f9fa' }}>
              <div
                style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '8px'
              }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "16px",
                  }}
                >
                    Total Records:{" "}
                  <b>{totalRecords}</b>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                    Records Per Page : {' '}
                  <Dropdown
                    inline
                    value={pageSize}
                    options={[5, 10, 50, 100].map((size) => ({
                      key: size,
                      text: size,
                      value: size,
                    }))}
                    onChange={(e, { value }) => handleSizeChange(value)}
                  />
                  {' '} &nbsp;&nbsp;&nbsp;&nbsp;
                    Go to Page {' '}
                  <Dropdown
                    inline
                    scrolling
                    value={currentPage}
                    options={Array.from(
                      { length: pageCount },
                      (_, index) => index + 1
                    ).map((i) => {
                      return {
                        key: i,
                        text: i,
                        value: i,
                      };
                    })}
                    onChange={(e, { value }) => handlePageClick(e,{activePage:Number(value)})}
                  /> {' '}
                </div>
                <div style={{padding:'10px'}}>
                <Pagination
                totalPages={pageCount}
                activePage={currentPage}
                onPageChange={handlePageClick}
                style={{ float: "right" }}
                ellipsisItem={{ content: <Icon name="ellipsis horizontal" />, icon: true }}
                firstItem={{ content: tooltip("angle double left", "First Page"), icon: true }}
                lastItem={{ content: tooltip("angle double right", "Last Page"), icon: true }}
                prevItem={{ content: tooltip("angle left", "Previous Page"), icon: true }}
                nextItem={{ content: tooltip("angle right", "Next Page"), icon: true }}
            /></div>
              </div>
            </td>
          </tr>
        </tfoot>
      ) : null}
    </table>
  );
};

export default ReactTable;
